import React, { useEffect } from "react";
import PropTypes from "prop-types";
import StepHeader from "../../components/StepHeader";
import displayEmployeesMassiveDeleteDeliveredBalances from "../../../../../../../usecases/employees/displays/display-employees-massive-delete-delivered-balances-table";

export default function DeliveredBalances({ content, data, ...rest }) {
  useEffect(() => {
    displayEmployeesMassiveDeleteDeliveredBalances({
      data,
      ...rest,
    });
  }, [data, rest]);

  return (
    <div>
      <StepHeader {...content} />
      <div id="employees-massive-delete-delivered-balances-table" />
    </div>
  );
}

DeliveredBalances.defaultProps = {
  employees: [],
  data: [],
};

DeliveredBalances.propTypes = {
  employees: PropTypes.array,
  content: PropTypes.object.isRequired,
  data: PropTypes.array,
};
